module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/book-appointment/book-appointment.component.html
// module id = ./src/app/Pages/tasks/book-appointment/book-appointment.component.html
// module chunks = main